module.exports = __webpack_public_path__ + "img/add.570c32f3.svg";